if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', class extends HTMLElement {
    constructor() {
      super();

      this.datasetType = this.dataset.type;
      this.sectionId = this.dataset.sectionId;

      this.recipientFields = this.querySelector('.recipient-fields');
      this.toggleButton = this.querySelector('.recipient-toggle-button');

      this.emailInput = this.querySelector(`#Recipient-email-${this.sectionId}`);
      this.nameInput = this.querySelector(`#Recipient-name-${this.sectionId}`);

      this.timezoneOffsetInput = this.querySelector(`#Recipient-timezone-offset-${this.sectionId}`);
      this.hiddenControlInput = this.querySelector(`#Recipient-control-${this.sectionId}`);

      this.toggleButton?.addEventListener('click', this.onToggle.bind(this));

      if (!this.toggleButton?.classList.contains('active')) {
        this.recipientFields?.classList.remove('visible');
        this.disableInputFields();
      } else {
        this.enableInputFields();
      }
    }

    inputFields() {
      return [this.emailInput, this.nameInput].filter(Boolean);
    }

    disableableFields() {
      return [this.timezoneOffsetInput, ...this.inputFields()].filter(Boolean); // RIMOSSO this.hiddenControlInput
    }

    onToggle() {
      const isActive = this.toggleButton.classList.toggle('active');

      this.recipientFields.classList.toggle('visible', isActive);

      if (isActive) {
        document.querySelectorAll('recipient-form').forEach((form) => {
          if (form !== this) {
            form.toggleButton?.classList.remove('active');
            form.recipientFields?.classList.remove('visible');
            form.clearInputFields();
            form.disableInputFields();
          }
        });
        this.enableInputFields();
      } else {
        this.clearInputFields();
        this.disableInputFields();
      }
    }

    enableInputFields() {
      this.disableableFields().forEach((field) => field.removeAttribute('disabled'));
      if (this.hiddenControlInput) this.hiddenControlInput.removeAttribute('disabled');
      if (this.timezoneOffsetInput) {
        this.timezoneOffsetInput.value = new Date().getTimezoneOffset().toString();
      }
    }
    
    disableInputFields() {
      this.disableableFields().forEach((field) => field.setAttribute('disabled', true));
      if (this.hiddenControlInput) this.hiddenControlInput.setAttribute('disabled', true);
    }

    clearInputFields() {
      this.inputFields().forEach((field) => (field.value = ''));
    }
  });
}
